import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Clock, UserCircle2, LogIn, Zap, Crown, Shield } from "lucide-react";
import { useAuth } from "../lib/auth";
import { useEntitlements } from "../lib/entitlements";

export const Brand = ({ onClick }) => (
  <div className="brand" onClick={onClick} data-testid="brand-logo">
    <div className="brand-mark">N</div>
    <span className="brand-name">
      Narc<b>Check</b> AI
    </span>
  </div>
);

export const NavBar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthed, user } = useAuth();
  const { is_pro, status, loaded } = useEntitlements();

  return (
    <header className="nav">
      <div className="container-nc nav-inner">
        <Brand onClick={() => navigate(is_pro ? "/app" : "/")} />
        <nav className="nav-actions">
          {loaded &&
            (is_pro ? (
              <span className="chip chip-brand" data-testid="pro-badge" style={{ borderColor: "var(--brand-2)", color: "var(--brand-2)", background: "transparent" }}>
                <Crown size={12} /> {status === "trialing" ? "Trial" : "Pro"}
              </span>
            ) : (
              <button
                className="chip chip-neutral"
                onClick={() => navigate("/paywall")}
                data-testid="subscribe-badge"
                style={{ cursor: "pointer", border: "1px solid var(--brand)", color: "var(--brand-2)" }}
                title="Subscribe to unlock"
              >
                <Zap size={12} color="var(--brand-2)" /> Subscribe
              </button>
            ))}
          <button
            className="btn-icon"
            title="History"
            onClick={() => navigate("/history")}
            data-testid="nav-history-btn"
            style={location.pathname === "/history" ? { borderColor: "var(--brand)" } : undefined}
          >
            <Clock size={18} />
          </button>
          {user?.role === "admin" && (
            <button
              className="btn-icon"
              title="Admin dashboard"
              onClick={() => navigate("/admin")}
              data-testid="nav-admin-btn"
              style={location.pathname === "/admin" ? { borderColor: "var(--brand)", color: "var(--brand-2)" } : { color: "var(--brand-2)" }}
            >
              <Shield size={18} />
            </button>
          )}
          {isAuthed ? (
            <button
              className="btn-icon"
              title="Account"
              onClick={() => navigate("/settings")}
              data-testid="nav-account-btn"
              style={{ color: "var(--brand-2)" }}
            >
              {user?.picture ? (
                <img
                  src={user.picture}
                  alt="me"
                  style={{ width: 26, height: 26, borderRadius: "50%" }}
                />
              ) : (
                <UserCircle2 size={20} />
              )}
            </button>
          ) : (
            <button
              className="btn btn-ghost"
              onClick={() => navigate("/sign-in")}
              data-testid="nav-signin-btn"
            >
              <LogIn size={16} /> <span className="nav-label">Sign in</span>
            </button>
          )}
        </nav>
      </div>
    </header>
  );
};
